import { initials } from "@/lib/api";
import avaPhoto from "@/assets/ava-thompson.png";

export const PersonAvatar = ({ name, size = 20, color, className = "" }) => {
  if (name === "Ava Thompson") {
    return (
      <img src={avaPhoto} alt="Ava Thompson" data-testid="ava-avatar"
        style={{ width: size, height: size }}
        className={`shrink-0 rounded-full object-cover ${className}`} />
    );
  }
  return (
    <span
      style={{
        width: size, height: size, fontSize: Math.max(7, Math.round(size * 0.36)),
        ...(color ? { background: `${color}22`, color } : {}),
      }}
      className={`flex shrink-0 items-center justify-center rounded-full font-semibold ${color ? "" : "bg-[rgba(79,142,247,0.15)] text-[#7FAEF9]"} ${className}`}>
      {initials(name)}
    </span>
  );
};
